import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(whithRootLayout)/learn-hoosh/context.tsx");
